import axios from '@/http.js';
export default {
  generateWork (data) {
      return axios.post('/api/aigc/generateWork', data);
  },
  generateWorkJson(data) {
    return axios.post('/api/aigc/generateWorkJson', data);
  }
}